import {
  Anchor,
  Container,
  Loader,
  Center,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { useIntl } from 'react-intl';
import { useParams, Link } from 'react-router';
import { useAppSelector } from '@store';
import routes from '@commons/routes';
import { QueryFolders } from '@/users/components/UserFolders';

export function UserQueryFoldersPage() {
  const intl = useIntl();
  const { username, filterId } = useParams();
  const filters = useAppSelector((state) => state.filters.filters);
  const isLoadingFilters = useAppSelector((state) => state.filters.isLoading);

  if (isLoadingFilters) {
    return (
      <Container size="xl" my="md">
        <Center h={250}>
          <Loader />
        </Center>
      </Container>
    );
  }

  const filter = filters.find((f: any) => f.id === filterId);

  if (!filter) {
    return (
      <Container my="md" size="xl">
        <Stack gap="md">
          <Text c="red">{intl.formatMessage({ id: 'filterNotFound' })}</Text>
          <Anchor
            component={Link}
            to={routes.routes.filters.list(username as string)}
          >
            {intl.formatMessage({ id: 'filters' })}
          </Anchor>
        </Stack>
      </Container>
    );
  }

  return (
    <Container my="md" size="xl" mb={300}>
      <Title order={4}>{filter.name}</Title>
      <QueryFolders filter={filter} />
    </Container>
  );
}
